module.exports = __webpack_public_path__ + "img/gateway.018301b8.webp";